// extracted by mini-css-extract-plugin
export var activeFilterButton = "_o2-c";
export var backButton = "_o2-4";
export var backIcon = "_o2-5";
export var chevronShortcut = "_o2-6";
export var container = "_o2-1";
export var editor = "_o2-8";
export var editorWrapper = "_o2-7";
export var prefix = "_o2-2";
export var searchIcon = "_o2-3";
export var suffix = "_o2-9";
export var suffixContent = "_o2-a";
export var suffixText = "_o2-b";
export var wrapper = "_o2-0";